import { useContentOverflow } from '../../../hooks'
import { Avatar } from '../../Avatar'
import { FloatingTooltip, FloatingTooltipContentText } from '../../Floating'
import Text from '../../Text'

import { ENTITY_MULTI_VALUE_ICON_SIZE } from './EntityMultiValue.constants'

import * as styles from './EntityMultiValue.module.css'

function EntityMultiValue({
  Icon,
  children,
  className = styles.EntityMultiValue,
  description,
  iconSize = ENTITY_MULTI_VALUE_ICON_SIZE,
  src,
  textContainerClassName = styles.textContainer,
  tooltipAdditionalText,
  tooltipContent,
  tooltipPlacement,
  unread,
  ...divProps
}) {
  const {
    overflow: overflowText,
    setContentOverflowRef: setTextContentOverflowRef,
  } = useContentOverflow()
  const {
    overflow: overflowDescription,
    setContentOverflowRef: setDescriptionContentOverflowRef,
  } = useContentOverflow()

  const tooltipProps = {
    content: (
      <FloatingTooltipContentText
        additionalText={tooltipAdditionalText || description}
        text={tooltipContent || children}
      />
    ),
    disabled: !overflowText && !overflowDescription,
    placement: tooltipPlacement,
  }

  return children ? (
    <div {...divProps} className={className}>
      {Icon ? <Avatar Icon={Icon} size={iconSize} src={src} /> : null}
      <FloatingTooltip {...tooltipProps}>
        <div className={textContainerClassName}>
          <Text ref={setTextContentOverflowRef} unread={unread}>
            {children}
          </Text>
          {description ? (
            <Text isSecondary ref={setDescriptionContentOverflowRef}>
              {description}
            </Text>
          ) : null}
        </div>
      </FloatingTooltip>
    </div>
  ) : null
}

export default EntityMultiValue
